import React from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { hideModal } from '../redux/actions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const styles = (theme) => ({
	dialogStyle: {
		'& .MuiDialog-paperWidthFalse': {
			[theme.breakpoints.down('sm')]: {
				width: '100%',
				maxWidth: '320px',
				margin: '15px',
			},
		},
	},
	titleStyle: {
		margin: 0,
		padding: 0,
	},
	closeButton: {
		position: 'absolute',
		zIndex: '111111',
		right: 0,
		top: 0,
		color: theme.palette.secondary.A200
	}
})

const ModalContainer = ({ Component, show, onHide, title, classes, params, canClose }) => {

	return (
		<div>
			<Dialog 
				data-testid="dialog"
				open={show} onClose={onHide}
				disableBackdropClick={params && params.disableBackdropClick ? true : false}
				maxWidth={false} className={'dialogStyle'}
				disableEscapeKeyDown={!canClose}>
				
                {canClose && (
				<IconButton
					data-testid="dialog-close-button"
					aria-label="close"
					className={classes.closeButton}
					onClick={params && params.onClose ? params.onClose : onHide}
					>
					<CloseIcon />
					</IconButton>)}
				{title && (
					<DialogTitle
						data-testid="dialog-title"
						id="form-dialog-title" className={classes.titleStyle}>
						{title}
					</DialogTitle>
				)}
				<DialogContent
					data-testid="dialog-content"
					style={{ padding: 0 }}>{Component && <Component  {...params} />}</DialogContent>
			</Dialog>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => ({
	Component: state.core.component,
	show: state.core.show,
	params: state.core.params,
	canClose: state.core.canClose
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onHide: () => dispatch(hideModal())
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))

export default enhance(ModalContainer)
